import { useState } from "react";

import { IPassedExerciseMetrics } from "@components/input-field/types/input-field.types";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";
import { TestStringResults } from "@typings/global.types";

import { useUpdateExercisesMutation } from "../../../api/exercises";

export function useExercisePassed() {
  const [
    // TODO: rename like hook name
    editExercises,
  ] = useUpdateExercisesMutation();

  const finishExercise = async (metrics: IPassedExerciseMetrics) => {
    await saveExercisePageData(metrics);
    return getExerciseRedirectUrl(metrics);
  };

  const saveExercisePageData = async (metrics: IPassedExerciseMetrics) => {
    if (metrics.isAuthorized) {
      await saveAuthorizedExercisePageData(metrics);
    } else {
      saveUnauthorizedExercisePageData(metrics);
    }
  };

  const saveAuthorizedExercisePageData = async (
    metrics: IPassedExerciseMetrics,
  ) => {
    const {
      exerciseId,
      speedRatio,
      mistakeLettersCount,
      correctLettersCount,
      gameMode,
      duration,
      coinsBeforeStart,
    } = metrics;

    const speed = calculateWPM(correctLettersCount, duration);
    const dateNow = new Date().toLocaleString("sv-SE", {
      timeZoneName: "short",
    });

    const payload = await editExercises({
      exerciseId,
      params: {
        speed,
        mistake: mistakeLettersCount,
        date: dateNow,
      },
    }).unwrap();

    window.sessionStorage.setItem(
      "exerciseCompleteData",
      JSON.stringify({
        speed,
        speedRatio,
        gameMode,
        coinsBeforeStart,
        mistake: mistakeLettersCount,
        ...payload,
      }),
    );
  };

  const saveUnauthorizedExercisePageData = (
    metrics: IPassedExerciseMetrics,
  ) => {
    const testStringResults: TestStringResults = {
      speed: calculateWPM(metrics.correctLettersCount, metrics.duration),
      speedRatio: metrics.speedRatio,
    };

    window.sessionStorage.setItem(
      "testStringResults",
      JSON.stringify(testStringResults),
    );
  };

  const getExerciseRedirectUrl = (metrics: IPassedExerciseMetrics): string => {
    if (metrics.isAuthorized) {
      return formatUrlWithLocale("/typing-tutor/exercise-results/");
    }

    return formatUrlWithLocale("/typing-tutor/test-string-results/");
  };

  const calculateWPM = (symbolsCount: number, time: number): number => {
    return Math.round((60000 * (symbolsCount - 1)) / time);
  };

  return {
    finishExercise,
  };
}
